module.exports = __webpack_public_path__ + "static/media/featureImg2.df7f6e5f.png";